import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    // Giris/auth istekleri kendi hatalarini yonetir; login/reset sayfasindayken de yonlendirme
    const isAuthRequest = /\/auth\/(login|forgot-password|reset-password|init)|\/member-portal\/login/.test(url);
    const path = window.location.pathname;
    const onAuthPage = path === '/login' || path === '/reset-password' || path === '/kayit';
    if (error.response?.status === 401 && !isAuthRequest && !onAuthPage) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
